import { URL_LIST_JOBS_OPEN } from '@seek/adv-constants';
import { useTranslations } from '@vocab/react';
import { Heading, Stack, Text, Box, TextLinkButton } from 'braid-design-system';
import React from 'react';

import { useLocalisedRoutes } from 'src/app/views/hooks/useLocalisedRoutes';
import { ErrorAlertOnSuccess } from 'src/app/views/pages/MultiLocation/components/errorAlert';
import Tick from 'src/app/views/pages/Success/components/ThankYouTick/Tick';

import translations from './.vocab';

export const Success = ({
  errorLocations,
}: {
  errorLocations: Array<string | undefined>;
}) => {
  const { t } = useTranslations(translations);

  const { goToExternalRoute } = useLocalisedRoutes();

  const handleOnClick = () => {
    goToExternalRoute(`${URL_LIST_JOBS_OPEN}?source=caja`);
  };

  return (
    <Stack space="medium" data={{ testid: 'multi-location-success-page' }}>
      <Heading level="2">{t('success-heading')}</Heading>
      <Text>{t('success-message')}</Text>
      <Text tone="link">
        <TextLinkButton onClick={handleOnClick} weight="weak">
          {t('success-button-text')}
        </TextLinkButton>
      </Text>
      <Box marginTop="medium" />
      {errorLocations.length > 0 ? (
        <ErrorAlertOnSuccess errorLocations={errorLocations} />
      ) : (
        <Tick />
      )}
    </Stack>
  );
};
